module.exports = __webpack_public_path__ + "media/images/transformers-1-0cc0000e20bbb201c9445e0cfbcebc57.jpg";